import { EntityReactionType } from "@shared/Types/Reactions/ReactionTypes.types";
import { getPositiveReactionsCountFromArray } from "@infrastructure/Persistence/Reactions";
import { useMemo } from "react";
import {
    ReactionDistributionDislikeBox,
    ReactionDistributionLikeBox,
    ReactionDistributionStack,
} from "./PostActionButtons.styles";

export function ReactionsDistribution({
    entityReactions,
    reactionCountSum,
}: {
    entityReactions: EntityReactionType[];
    reactionCountSum: number;
}) {
    const likePercentage = useMemo(
        () =>
            getPositiveReactionsCountFromArray(entityReactions) /
            reactionCountSum,

        [entityReactions],
    );

    return (
        <ReactionDistributionStack>
            {!!likePercentage && (
                <ReactionDistributionLikeBox
                    flex={likePercentage}
                    marginRight={likePercentage === 1 ? 0 : "2px"}
                />
            )}
            <ReactionDistributionDislikeBox flex={1 - likePercentage} />
        </ReactionDistributionStack>
    );
}
